export default __webpack_public_path__ + "static/media/gallery2.8f4ec524.jpg";